import { render } from "./DialogCallback.vue?vue&type=template&id=7e93d978&scoped=true"
import script from "./DialogCallback.vue?vue&type=script&lang=js"
export * from "./DialogCallback.vue?vue&type=script&lang=js"

import "./DialogCallback.vue?vue&type=style&index=0&id=7e93d978&scoped=true&lang=css"

import exportComponent from "/Users/nikita/Documents/works/novosel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e93d978"]])

export default __exports__